export const BANNER_LIST_ACTION = "BANNER_LIST_ACTION";
export const BANNER_LIST_SUCCESS = "BANNER_LIST_SUCCESS";
export const BANNER_CREATE_ACTION = "BANNER_CREATE_ACTION";
export const BANNER_DELETE_ACTION = "BANNER_DELETE_ACTION";
export const BANNER_GET_UPDATE_ACTION = "BANNER_GET_UPDATE_ACTION";
export const BANNER_GET_UPDATE_SUCCESS = "BANNER_GET_UPDATE_SUCCESS";
export const BANNER_UPDATE_ACTION = "BANNER_UPDATE_ACTION";
export const BANNER_FAIL = "BANNER_FAIL";

export const BANNER_CREATE_TRANSLATE_ACTION = "BANNER_CREATE_TRANSLATE_ACTION";
export const BANNER_CREATE_TRANSLATE_SUCCESS = "BANNER_CREATE_TRANSLATE_SUCCESS";

export const BANNER_UPDATE_TRANSLATE_ACTION = "BANNER_UPDATE_TRANSLATE_ACTION";
export const BANNER_UPDATE_TRANSLATE_SUCCESS = "BANNER_UPDATE_TRANSLATE_SUCCESS";

export const BANNER_DELETE_TRANSLATE_ACTION = "BANNER_DELETE_TRANSLATE_ACTION";
export const BANNER_DELETE_TRANSLATE_SUCCESS = "BANNER_DELETE_TRANSLATE_SUCCESS";
